import Vue from '@vue/compat';
import vipPageOptions from './vip-page.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

window.qkVipPage = mountPage('.vip-body', vipPageOptions);

export { vipPageOptions };
